import { render } from "./MemberBulkUpload.vue?vue&type=template&id=830b4660&scoped=true"
import script from "./MemberBulkUpload.vue?vue&type=script&lang=js"
export * from "./MemberBulkUpload.vue?vue&type=script&lang=js"

import "./MemberBulkUpload.vue?vue&type=style&index=0&id=830b4660&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/CBHI/PONA HEALTH/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-830b4660"]])

export default __exports__